<template>
  <div class="rounded-lg bg-white overflow-hidden border-1 border-border border-solid mb-base p-base shadow-card transition-all duration-150 flex space-between hover:shadow-cardHover hover:bg-cardBackgroundHover">
    <div class="inline-block flex-grow w-paymentMethodInfo">
      <div>
        <div id="payment-method-top-row" class="mb-xs">
          <VLabel v-if="method.is_default" type="info" class="default-label" id="payment-method-default-label">
            <template v-slot:text>
              {{ $t('companySettings.billing.paymentMethods.default') }}
            </template>
          </VLabel>
          <span v-if="method.type === 'Card'">
            <b id="payment-method-card-funding">{{ method.card.brand }} ({{ $t(`companySettings.billing.paymentMethods.funding.${ method.card.funding }`) }})</b> - {{ $t('companySettings.billing.paymentMethods.ending') }} <b id="payment-method-card-last4">{{ method.card.last4 }}</b>
          </span>
          <span v-if="method.type === 'Source'">
            <b id="payment-method-direct-debit-title">{{ $t('companySettings.billing.paymentMethods.directDebit') }}</b> - {{ $t('companySettings.billing.paymentMethods.ending') }}
            <span class="font-bold" id="payment-method-direct-debit-last4">{{ method.bacs_debit.last4 }}</span>
          </span>
        </div>
        <div id="payment-method-bottom-row" class="text-gray-400">
          <span v-if="method.type === 'Card'">
            <p id="payment-method-card-expiry">{{ $t('companySettings.billing.paymentMethods.expires') }} {{ method.card.exp_month }}/{{ method.card.exp_year }}</p>
          </span>
          <span v-if="method.type === 'Source'">
            <span id="payment-method-direct-debit-sort" class="whitespace-nowrap mr-xs inline-block">
            {{ $t(`companySettings.billing.paymentMethods.sortCode`) }} {{ extractSort(method.bacs_debit.sort_code) }}
            </span>
            <span id="payment-method-direct-debit-created" class="whitespace-nowrap inline-block">{{ $t('functional.created') }} {{ method.created | formatDate('short') }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="inline-flex flex-wrap justify-end content-start items-start gap-sm">
      <VButton
          id="payment-method-view-mandate-button"
          :href="method.bacs_debit.url"
          target="_blank"
          type="outline-1"
          size="small"
          data-ec="billing_payment_method_card"
          data-et="view_mandate_button"
          v-if="method.type === 'Source'">
        {{ $t('companySettings.billing.viewMandate') }}
      </VButton>
      <VButton
          id="payment-method-default-button"
          @click.native="openSwitchModal"
          type="outline-1"
          size="small"
          data-ec="billing_payment_method_card"
          data-et="set_as_default_button"
          v-if="!method.is_default">
        {{ $t('companySettings.billing.paymentMethods.setAsDefault') }}
      </VButton>
      <VButton
          id="payment-method-delete-button"
          @click.native="openDeleteModal"
          type="outline-error"
          size="small"
          data-ec="billing_payment_method_card"
          data-et="delete_button">
        {{ $t('functional.delete') }}
      </VButton>
    </div>
  </div>
</template>

<script>

import VButton from '@/components/deprecated/atoms/Button.vue';
import VLabel from '@/components/deprecated/atoms/Label.vue';

export default {
  name: 'BillingPaymentMethod',
  components: {
    VButton,
    VLabel,
  },
  props: {
    method: Object,
  },
  methods: {
    openSwitchModal() {
      this.$emit('openSwitchModal');
    },
    openDeleteModal() {
      this.$emit('openDeleteModal');
    },
    extractSort(sort) {
      return `${sort.slice(0, 2)}-${sort.slice(2, 4)}-${sort.slice(4, 6)}`;
    },
  },
};
</script>

<style scoped>
/* Remove once label refactored */
.default-label {
  margin-bottom: 0;
  margin-right: var(--spacing-small);
  float: none;
  display: inline-block;
  vertical-align: middle;
}
</style>

